import { render, staticRenderFns } from "./StudyListItem.vue?vue&type=template&id=5dba826e&"
import script from "./StudyListItem.vue?vue&type=script&lang=ts&"
export * from "./StudyListItem.vue?vue&type=script&lang=ts&"
import style0 from "./StudyListItem.vue?vue&type=style&index=0&id=5dba826e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports